export const LOCAL_STORAGE_KEYS = {
  APP_MODE: 'app.mode',
  APP_WEB_VIEW: 'app.webView',
  APP_APP_TYPE: 'app.appType',
  TRIAL_WARNING_SHOWN_AT: 'trialWarningShownAt',
  OVERDUE_WARNING_SHOWN_AT: 'overdueWarningShownAt',
  // offline migration ------------------------------
  OFFLINE_MIGRATION_WELCOME_FIRST_SHOWN_AT: 'offlineMigrationWelcomeFirstShownAt',
  OFFLINE_MIGRATION_WELCOME_SHOWN_AT: 'offlineMigrationWelcomeShownAt',
  OFFLINE_MIGRATION_REMINDER_SHOWN_AT: 'offlineMigrationReminderShownAt',
  OFFLINE_MIGRATION_SUBSCRIPTION_FIRST_SHOWN_AT: 'offlineMigrationSubscriptionFirstShownAt',
  OFFLINE_MIGRATION_EXIT_SHOWN_AT: 'offlineMigrationExitShownAt',
  OFFLINE_MIGRATION_PAY_BY_CARD_SHOWN_AT: 'offlineMigrationPayByCardShownAt',
  // /offline migration -----------------------------

  // versum migration---------------------
  VERSUM_MIGRATION_SUBSCRIPTION_FIRST_SHOWN_AT: 'versumMigrationSubscriptionFirstShownAt',
  VERSUM_MIGRATION_SUBSCRIPTION_LAST_SHOWN_AT: 'versumMigrationSubscriptionLastShownAt',
  VERSUM_MIGRATION_SUBSCRIPTION_LAST_DAY_DISPLAYED: 'versumMigrationSubscriptionLastDayDisplayed',
  // versum migration---------------------

  CALENDAR_SETTINGS: 'calendar.settings',
  CALENDAR_IMPORT_FEATURE_ALREADY_VISITED: 'calendar.importFeatureAlreadyVisited',
  WHOS_NEXT_EXPANDED_KEY: 'whos-next.expanded',
  SHOWN_WALKTHROUGHS: 'shownWalkthroughs',
  BOOKSY_TOOLBELT_DEBUG_EVENTS: 'booksy_toolbelt_debug_events',
  INSTAGRAM_ACCESS_TOKEN_KEY: 'instagramAccessToken',
  INSTAGRAM_REDIRECT_PATH: 'instagramRedirectPath',
  RICH_TEXT_VERSION: 'richTextVersion',

  BUSINESSES_OPENED: 'businessesOpened',

  BCR_LAST_CONNECTED_READER_SN: 'bcr_last_connected_reader_sn',
  BCR_BUSY_READERS: 'bcr_busy_readers', // only for analytics

  USE_NATIVE_LOCATION: 'useNativeLocation',

  SHARE_PROFILE_TOOLTIP_SHOWN: 'shareProfileTooltipShown',
  LEGACY_SHOW_BOOKING_MODE_MODAL_COUNTER: 'showBookingModeModalCounter',
  SHOW_BOOKING_MODE_MODAL_COUNTER: 'showBookingModeModalCounter_v2',

  // google address experiment
  GOOGLE_ADDRESS_LAST_VIEW: 'googleAddressLastView',

  // black friday promotion
  BLACK_FRIDAY_DOT_INDICATOR_DISABLED: 'blackFriday2025DotIndicatorDisabled',
  BLACK_FRIDAY_BANNER_DISABLED: 'blackFriday2025BannerDisabled',
}
